<template>
    <div
        :class="['personas', alignRight && 'right']"
    >
        <transition
            appear
            name="fade"
            mode="out-in"
            @before-leave="$root.prepareHeightChange"
            @enter="$root.executeHeightChange"
        >
            <div v-if="selectedKey === null" class="list">
                <h4>Pädagogische Fachkräfte</h4>
                <div class="row">
                    <Teaser
                        v-for="key in teachers"
                        :key="key"
                        :name="personas[key].name"
                        :attribute="personas[key].attribute"
                        @click.native="showProfile(key)"
                    />
                </div>
                <h4>Eltern</h4>
                <div class="row">
                    <Teaser
                        v-for="key in parents"
                        :key="key"
                        :name="personas[key].name"
                        :attribute="personas[key].attribute"
                        @click.native="showProfile(key)"
                    />
                </div>
                <ControlButton
                    :active="true"
                    @click="$router.go(-1)"
                >
                    Zurück
                </ControlButton>
            </div>
            <div
                v-else
                :key="selectedKey"
                class="profile"
            >
                <TextBox
                    background="blue"
                >
                    {{ personas[selectedKey].text }}
                </TextBox>
                <ControlButton
                    :active="true"
                    @click="showList()"
                >
                    Zurück
                </ControlButton>
            </div>
        </transition>
    </div>
</template>

<script>
import personas from '@/static/personas.json';
import Teaser from '@/components/views/Personas/Teaser';

const backgrounds = [
    {id: 'persona_1', src: require('@/assets/personas/persona_1_bg.jpg')},
    {id: 'persona_2', src: require('@/assets/modules/2.1/bgs/bg07.jpg')},
    {id: 'persona_3', src: require('@/assets/modules/2.3/bgs/bg09.jpg')},
    {id: 'persona_4', src: require('@/assets/modules/2.1/bgs/bg10.jpg')},
    {id: 'persona_5', src: require('@/assets/modules/2.2/bgs/bg05.jpg')},
    {id: 'persona_6', src: require('@/assets/modules/2.3/bgs/bg04.jpg')}
];

export default {
    name: 'Personas',
    components: {
        Teaser
    },
    data: () => ({
        personas,
        teachers: ['persona_1', 'persona_2', 'persona_3'],
        parents: ['persona_4', 'persona_5', 'persona_6'],
        selectedKey: null,
        alignRight: false
    }),
    mounted()
    {
        this.$root.loadCanvasBackgrounds(backgrounds);
        this.$root.resetHeader('Übersicht');
    },
    methods: {
        showProfile(key)
        {
            this.selectedKey = key;
            const persona = this.personas[key];
            this.alignRight = !!persona.right;
            this.$root.animateTransition({
                duration: 0.5,
                inset: persona.right ? {left: '52%'} : {right: '52%'},
                image: key,
                swoosh: true
            });
        },
        showList()
        {
            this.selectedKey = null;
            this.$root.animateTransition({
                duration: 0.5,
                inset: {},
                image: '',
                swoosh: true
            });
        }
    }
};
</script>

<style lang="scss" src="./Personas.scss" />
